import React from 'react';
import { ROLE, ROLEALL, PERMISSION } from "../../services/actions";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import RFG from '../../libs/inputs/RFG';
import { BsBoxFill, BsPencilSquare, BsTrashFill, BsPlusSquareFill, BsKeyFill, BsCheckCircleFill, BsDashCircleFill } from "react-icons/bs";
import Swal from 'sweetalert2';
import SearchableList from '../../libs/list/SearchableList';
import { Container, Button, Box, Grid, Typography, Badge } from "@mui/material";
import RDialog from '../extra/RDialog';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function Role() {
    let dispatch = useDispatch()
    let roleState = useSelector((state) => state?.roleState)
    let roleallState = useSelector((state) => state?.roleallState)
    const [view, setView] = React.useState(1)
    const [selectedRole, setSelectedRole] = React.useState()
    const [openDlg, setOpenDlg] = React.useState()
    const [openPemissionDlg, setOpenPemissionDlg] = React.useState([])

    const { handleSubmit, control, reset } = useForm({ defaultValues: {}, mode: "all" })

    React.useEffect(() => {
        dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
    }, [])

    React.useEffect(() => {
        dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
        console.log("DATA", roleallState?.data?.results)
        // for (let role of roleallState?.data?.results || []) {
        //     console.log("*****************", selectedRole,"--==", role)
        //     if (role.name == selectedRole) {
        //         formatData(role)
        //         break
        //     }
        // }
    }, [roleState?.data])

    const confirm2 = (event, data) => {
        Swal.fire({
            title: "Do you want to delete?",
            showDenyButton: true,
            confirmButtonText: "Cancel",
            denyButtonText: `Delete`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isDenied) {
                onDelete(data)

            }
        })
    };

    const onSubmit = (data) => {
        let action = data.id ? `${ROLE}_PATCH` : `${ROLE}_POST`
        dispatch({
            type: action, payload: data, callback: (resp) => {
                dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
            }
        });
    }

    const onDelete = (data) => {
        let action = data.id ? `${ROLE}_DELETE` : `${ROLE}_POST`
        dispatch({
            type: action, payload: data.id, callback: (resp) => {
                dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
            }
        });
    }

    const findPermissions = ()=>{


    }

    const formatData = (role) => {
        if (!role?.name) return null
        setView(2)
        setSelectedRole(role.name)
        let assigned = role._assigned
        let all = role?._permission ? Object.keys(role?._permission).map((key) => {

            let access = { role: role.name, value: key, name: key }
            for (let _access of role?._permission[key]) {
                let per = _access.codename.split("_")[0]
                access[per] = _access.codename
                access[`${per}_assigned`] = false
                if (assigned[key]) {
                    for (let _assigned of assigned[key]) {
                        if (_access.codename == _assigned.codename) {
                            access[`${per}_assigned`] = true
                            break
                        }

                    }
                }
            }

            return access
        }) : []

        setOpenPemissionDlg(all)
        return all
    }

    const addPermission = (role, permission, action) => {
        let data = {
            id: 0,
            name: role,
            permissions: [permission],
            action: action ? "add" : "remove"
        }
        dispatch({
            type: `${ROLE}_PATCH`, payload: data, callback: (resp) => {
                // dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
                console.log("Hello", resp)
                formatData(resp)
            }
        });
    }

    const updatedBtn = (status) => status ? <BsCheckCircleFill color="green" /> : <BsDashCircleFill color="#c71616" />

    return (
        <>
            {view == 2 ? <Box>
                <Button className={'btn-primary'} size='md' onClick={() => setView(1)} sx={{ m: 2 }}>Back</Button>
                <TableContainer sx={{ p: 3 }}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Permissions for {selectedRole}</TableCell>
                                <TableCell align="right">Add</TableCell>
                                <TableCell align="right">View</TableCell>
                                <TableCell align="right">Update</TableCell>
                                <TableCell align="right">Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {openPemissionDlg.map((option) => (
                                <TableRow
                                    key={option.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {option.name}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Badge bg={option.add_assigned ? 'success' : 'danger'}
                                            onClick={(e) => {
                                                addPermission(option.role, option.add, !option.add_assigned)
                                            }}
                                        >
                                            {updatedBtn(option.add_assigned)}
                                        </Badge>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Badge bg={option.view_assigned ? 'success' : 'danger'}
                                            onClick={(e) => {
                                                addPermission(option.role, option.view, !option.view_assigned)
                                            }}
                                        >
                                            {updatedBtn(option.view_assigned)}
                                        </Badge>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Badge bg={option.change_assigned ? 'success' : 'danger'}
                                            onClick={(e) => {
                                                addPermission(option.role, option.change, !option.change_assigned)
                                            }}
                                        >
                                            {updatedBtn(option.change_assigned)}
                                        </Badge>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Badge bg={option.delete_assigned ? 'success' : 'danger'}
                                            onClick={(e) => {
                                                addPermission(option.role, option.delete, !option.delete_assigned)
                                            }}
                                        >
                                            {updatedBtn(option.delete_assigned)}
                                        </Badge>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box> :
                <Grid container spacing={2} sx={{ px: 3 }}>
                    <Grid size={{ xs: 12, sm: 4 }} sx={{ my: 3 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="pt-2 pb-3">
                                <RFG name="id" control={control}>
                                    <input type="hidden" />
                                </RFG>
                                <RFG name="name" label="Role" control={control} rules={{ required: true }} className="mb-2 p-inputtext-sm">
                                    <input />
                                </RFG>
                            </div>
                            <Box sx={{ my: 3 }}>
                                <Button type="submit" className={'btn-primary'} size='md' >Submit</Button>
                            </Box>
                        </form>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }} sx={{ my: 5 , pt:2}}>
                        <SearchableList
                            onClick={(i, data) => { if (i == 0) confirm2(i, data); if (i == 1) formatData(data) }}
                            buttons={[
                                <BsTrashFill style={{ marginRight: 3 }} fontSize={16} color="red" />,
                                <BsKeyFill fontSize={20} color="orange" />
                            ]}
                            // headerButtons={[<BsPlusSquareFill fontSize={20} color="orange" onClick={() => { setOpenDlg(true) }} />]}
                            optionLabel="name"
                            list={roleallState?.data?.results}
                        />
                    </Grid>
                </Grid>}
        </>
    )
}